import React, { PureComponent } from 'react';
import AutoSuggest from 'react-autosuggest';
import { debounce, identity } from 'lodash/fp';
import { Icon } from 'ui';
import request from 'utils/request_ajax';
import { TYPE_ICONS } from 'constants/config';

class RemoteAutoSuggest extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],
      query: this.props.defaultValue || '',
    };

    this.onDebouncedFetchRequested = debounce(props.wait)(
      this.onSuggestionFetchRequested,
    );
  }

  static defaultProps = {
    wait: 250,
    queryParam: 'query',
    suggestionNameKey: 'name',
    shouldRenderSuggestions: value => value.trim().length > 0,
    mapResponseToSuggestions: identity,
    onSuggestionSelected: identity,
  };

  renderSuggestion = suggestion => {
    const icon = TYPE_ICONS[suggestion.type];

    return (
      <div className="p-4-0">
        {icon && <i className="mr-4" children={<Icon name={icon} />} />}
        {this.getSuggestionValue(suggestion)}
      </div>
    );
  };

  getSuggestionValue = suggestion => {
    const { suggestionNameKey } = this.props;
    return suggestion[suggestionNameKey];
  };

  onInputChange = (e, { newValue }) => {
    this.setState({ query: newValue });
  };

  onSuggestionFetchRequested = ({ value }) => {
    const { url, queryParam } = this.props;
    request.get(url, { [queryParam]: value }).then(res => {
      this.setState({
        suggestions: res.data,
      });
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] });
  };

  onSuggestionSelected = (e, { suggestion }) => {
    this.props.onSuggestionSelected(e, suggestion);
    this.setState({ query: this.getSuggestionValue(suggestion) });
  };

  render() {
    return (
      <AutoSuggest
        suggestions={this.state.suggestions}
        renderSuggestion={this.renderSuggestion}
        getSuggestionValue={this.getSuggestionValue}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        onSuggestionsFetchRequested={this.onDebouncedFetchRequested}
        shouldRenderSuggestions={this.props.shouldRenderSuggestions}
        inputProps={{
          name: this.props.name,
          placeholder: this.props.placeholder,
          onChange: this.onInputChange,
          value: this.state.query,
          className: 'NewInput NewInput--light m-0',
        }}
      />
    );
  }
}

export default RemoteAutoSuggest;
